import JassEnum from './enum';

/**
 * type gamedifficulty
 */
export default class JassGameDifficulty extends JassEnum {}
